const ManufacturerGlnSource = {
  INFORMATION_PROVIDER: 'INFORMATION_PROVIDER',
  BRAND_OWNER: 'BRAND_OWNER',
  MANUFACTURER: 'MANUFACTURER',
};

const ManufacturerGlnSourceOptions = [
  { value: null, label: 'None (Default)' },
  { value: ManufacturerGlnSource.INFORMATION_PROVIDER, label: 'Information Provider' },
  { value: ManufacturerGlnSource.BRAND_OWNER, label: 'Brand Owner' },
  { value: ManufacturerGlnSource.MANUFACTURER, label: 'Manufacturer' },
];

export { ManufacturerGlnSource, ManufacturerGlnSourceOptions };
